import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import NewslettersPageForm from '../../../../components/newsletters/newsletters_page_form_with_state';
import nlData from './newsletters_page_data';
import loadData from './newsletters_page_state_manager';
import Slug from '../../../../../views/components/slug/slug';

class NewsletterPage extends Component {
  static loadData(store) {
    return loadData(store);
  }

  constructor(props) {
    super(props);

    this.state = {
      compass: true,
      codesign: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(e) {
    const list = e.target.id;
    const val = e.target.checked;
    if (list === 'codesign') {
      this.setState({
        codesign: val
      });
    } else if (list === 'compass') {
      this.setState({
        compass: val
      });
    }
  }

  render() {
    if (this.props.staticPage.error) {
      return (
        <section className="wp-page">
          <article className="wp-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.staticPage.isLoading) {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { config } = this.props;
    const newslettersConfig = get(config, 'newsletters');
    const listsDictionary = get(newslettersConfig, 'listsById');
    const allIds = get(newslettersConfig, 'allIds');
    const listIds = [];
    if (this.state.compass === true) {
      listIds.push(497);
    }
    if (this.state.codesign === true) {
      listIds.push(573);
    }

    return (
      <div>
        <Slug slugName="Newsletters" className="category-page" />

        <h3 className="page-description">
          Choose one or MORE newsletters to appear in your inbox
        </h3>
        <div className="news-container">
          <div className="news-container__choice">
            <img
              src="https://images.fastcompany.net/image/upload/v1605295030/fcweb/compass-logo_dt5tvi.svg"
              alt="compass logo"
            />
            <div>
              <input
                type="checkbox"
                id="compass"
                onChange={this.handleInputChange}
                defaultChecked={true}
              />
              <p>
                Our daily email helping you smartly navigate the most important
                news in business, innovation, and creativity.
              </p>
            </div>
          </div>
          <span className="newsletter-spacer" />
          <div className="news-container__choice">
            <img
              src="https://images.fastcompany.net/image/upload/v1605295124/fcweb/Layer_2_ftj8uf.svg"
              alt="co design logo"
            />
            <div>
              <input
                type="checkbox"
                id="codesign"
                onChange={this.handleInputChange}
                defaultChecked={true}
              />
              <p>
                Our daily email with a focus on where business and design
                collide.
              </p>
            </div>
          </div>
        </div>
        <section className="container">
          <NewslettersPageForm
            config={config}
            newsletterIds={allIds}
            listsDictionary={listsDictionary}
            sections={nlData}
            hed=""
            dek=""
            listIds={listIds}
          />
        </section>
      </div>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    staticPage: state.staticPage || {},
    config: state.config
  };
}

NewsletterPage.propTypes = {
  config: PropTypes.shape({
    newsletters: PropTypes.shape({}).isRequired
  }).isRequired,
  staticPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired
};

export default connect(mapStateToProps)(NewsletterPage);
